import { styled, Box } from "@mui/material";

const NavbarBrand = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  fontSize: "large",
  fontWeight: "800",
  height: "64px",
}));

export default NavbarBrand;
